"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectPatient = exports.SelectParticipants = exports.SelectClinician = void 0;
require("antd/lib/form/style");
var _form = _interopRequireDefault(require("antd/lib/form"));
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
require("antd/lib/select/style");
var _select = _interopRequireDefault(require("antd/lib/select"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _utils = require("../../../utils");
var _ = require("../..");
var _ScreenTitle = require("./ScreenTitle");
var _useManagerAppointmentCubby = require("../useManagerAppointmentCubby");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Option = _select.default.Option;
var composePatientOptionString = function composePatientOptionString(patient) {
  var firstName = patient.firstName,
    lastName = patient.lastName,
    nickName = patient.nickName;
  var nameString = (0, _utils.composeName)([lastName, firstName]);
  var nickNameString = nameString ? "(".concat(nickName, ")") : nickName;
  return "".concat(nameString, " ").concat(nickNameString).trim();
};

// Helper function to determine what to render for each Select component
var getNotFoundContent = function getNotFoundContent(_ref) {
  var loading = _ref.loading,
    data = _ref.data,
    participantTypes = _ref.participantTypes,
    member = _ref.member,
    isMemberSelected = _ref.isMemberSelected;
  var noParticipantsFound = isMemberSelected && !(data !== null && data !== void 0 && data.length);
  return loading ? /*#__PURE__*/_react.default.createElement(_spin.default, {
    size: "small"
  }) : noParticipantsFound ? "No ".concat(participantTypes, " found for this ").concat(member, ".") : "No ".concat(participantTypes, " found.");
};
var SelectPatient = function SelectPatient(_ref2) {
  var selectedPatient = _ref2.selectedPatient,
    clinician = _ref2.clinician,
    includeRecurringRules = _ref2.includeRecurringRules,
    onPatientSelect = _ref2.onPatientSelect,
    onError = _ref2.onError;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    patientSearchQuery = _useState2[0],
    setPatientSearchQuery = _useState2[1];
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  var _useRequest = (0, _utils.useRequest)(function () {
      var query = {
        query: patientSearchQuery
      };
      if (includeRecurringRules) {
        query.include = ['recurringRules'];
      }
      return (0, _utils.getSearchPatientsUrl)(query, clinician === null || clinician === void 0 ? void 0 : clinician.id);
    }, {
      refreshDeps: [clinician, patientSearchQuery],
      debounceWait: 700,
      onError: onError
    }),
    _useRequest$data = _useRequest.data,
    patients = _useRequest$data === void 0 ? [] : _useRequest$data,
    patientsLoading = _useRequest.loading;
  var handleChange = function handleChange(value) {
    if (!value) {
      setPatientSearchQuery('');
    }
    onPatientSelect((0, _lodash.find)(patients, {
      id: value
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Patient"
  }, /*#__PURE__*/_react.default.createElement(_select.default, {
    className: "w-full"
    // Don't render ID by accident
    ,
    value: (0, _lodash.isEmpty)(patients) ? null : selectedPatient === null || selectedPatient === void 0 ? void 0 : selectedPatient.id,
    showSearch: true,
    allowClear: true,
    filterOption: false,
    showArrow: false,
    notFoundContent: (0, _utils.isClinician)(user) ? 'No patients found.' : getNotFoundContent({
      loading: patientsLoading,
      data: patients,
      participantTypes: 'patients',
      member: 'clinician',
      isMemberSelected: !!clinician
    }),
    onChange: handleChange,
    onSearch: setPatientSearchQuery
  }, patients.map(function (patient) {
    return /*#__PURE__*/_react.default.createElement(Option, {
      key: patient.id,
      value: patient.id
    }, composePatientOptionString(patient));
  })));
};
exports.SelectPatient = SelectPatient;
var SelectClinician = function SelectClinician(_ref3) {
  var selectedClinician = _ref3.selectedClinician,
    patient = _ref3.patient,
    onClinicianSelect = _ref3.onClinicianSelect,
    onError = _ref3.onError;
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    clinicianSearchQuery = _useState4[0],
    setClinicianSearchQuery = _useState4[1];
  var _useRequest2 = (0, _utils.useRequest)(function () {
      return !(0, _lodash.isEmpty)(patient) ? (0, _utils.getPatientCareTeamUrl)(patient.id) : (0, _utils.getSearchCliniciansUrl)({
        query: clinicianSearchQuery
      });
    }, {
      refreshDeps: [patient, clinicianSearchQuery],
      debounceWait: 300,
      onError: onError
    }),
    _useRequest2$data = _useRequest2.data,
    clinicians = _useRequest2$data === void 0 ? [] : _useRequest2$data,
    cliniciansLoading = _useRequest2.loading;
  var handleChange = function handleChange(value) {
    if (!value) {
      setClinicianSearchQuery('');
    }
    onClinicianSelect((0, _lodash.find)(clinicians, {
      id: value
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Clinician"
  }, /*#__PURE__*/_react.default.createElement(_select.default, {
    className: "w-full"
    // Don't render ID by accident
    ,
    value: (0, _lodash.isEmpty)(clinicians) ? null : selectedClinician === null || selectedClinician === void 0 ? void 0 : selectedClinician.id,
    showSearch: true,
    allowClear: true,
    filterOption: false,
    showArrow: false,
    notFoundContent: getNotFoundContent({
      loading: cliniciansLoading,
      data: clinicians,
      participantTypes: 'clinicians',
      member: 'member',
      isMemberSelected: !!patient
    }),
    onChange: handleChange,
    onSearch: setClinicianSearchQuery
  }, clinicians.map(function (clinician) {
    return /*#__PURE__*/_react.default.createElement(Option, {
      key: clinician.id,
      value: clinician.id
    }, (0, _utils.composeName)([clinician.lastName, clinician.firstName]));
  })));
};
exports.SelectClinician = SelectClinician;
var SelectParticipants = function SelectParticipants(_ref4) {
  var selectedPatient = _ref4.selectedPatient,
    selectedClinician = _ref4.selectedClinician,
    includeRecurringRules = _ref4.includeRecurringRules,
    onClinicianSelect = _ref4.onClinicianSelect,
    onPatientSelect = _ref4.onPatientSelect;
  var _useManagerAppointmen = (0, _useManagerAppointmentCubby.useManagerAppointmentCubby)(),
    targetClinician = _useManagerAppointmen.targetClinician,
    targetPatient = _useManagerAppointmen.targetPatient;
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    patientsError = _useState6[0],
    setPatientsError = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = _slicedToArray(_useState7, 2),
    cliniciansError = _useState8[0],
    setCliniciansError = _useState8[1];
  var clinicianNotPreSelected = (0, _lodash.isEmpty)(targetClinician);
  var patientNotPreSelected = (0, _lodash.isEmpty)(targetPatient);
  var title = "Select a ".concat((0, _lodash.compact)([patientNotPreSelected ? 'patient' : null, clinicianNotPreSelected ? 'clinician' : null]).join(' and '));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ScreenTitle.ScreenTitle, null, title), patientsError || cliniciansError ? 'There was a problem retrieving the list of users.' : /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col gap-y-[16px]"
  }, patientNotPreSelected && /*#__PURE__*/_react.default.createElement(SelectPatient, {
    selectedPatient: selectedPatient,
    clinician: selectedClinician,
    includeRecurringRules: includeRecurringRules,
    onPatientSelect: onPatientSelect,
    onError: setPatientsError
  }), clinicianNotPreSelected && /*#__PURE__*/_react.default.createElement(SelectClinician, {
    selectedClinician: selectedClinician,
    patient: selectedPatient,
    onClinicianSelect: onClinicianSelect,
    onError: setCliniciansError
  })));
};
exports.SelectParticipants = SelectParticipants;